import React from 'react';
import CategoryNavigation from '@Client/runner.nav.categories/components/CategoryNavigation';
import CategoryNavigationMobile from '@Client/runner.nav.categories/components/CategoryNavigationMobile';
import { ITreeCategory } from '@Client/runner.services/runner.category-navigation.service';

type Props = {
  isMobile: boolean;
  categorisedItems: ITreeCategory<any>[];
  allCategoriesId: string;
  recentlyViewed?: string;
  onCategoryClick: (id: string, index?: string) => void;
  selectedCategoryId: string;
  expandedCategory?: string[];
};
const Category = (props: Props) => {
  const {
    categorisedItems,
    isMobile,
    allCategoriesId,
    recentlyViewed,
    onCategoryClick,
    selectedCategoryId,
    expandedCategory
  } = props;

  const categories = [
    { text: 'All', id: allCategoriesId, flowModels: [], items: [] },
    ...(recentlyViewed
      ? [
          {
            text: 'Recently Viewed',
            id: recentlyViewed,
            flowModels: [],
            items: []
          }
        ]
      : []),
    ...categorisedItems
  ];

  return isMobile ? (
    <div className="imin-groupsandfilters m-0 mr-30 row p-0 runner-contents-area mt-40">
      <div className="col s10 m6 l4 p-0">
        <div className="row valign-wrapper mt-10 mb-0 mr-0 ml-15">
          <CategoryNavigationMobile
            categories={categories}
            categoryClicked={onCategoryClick}
          />
        </div>
      </div>
    </div>
  ) : (
    <div className="categories-col">
      <h4 className="pl-15">
        <b>Categories</b>
      </h4>
      <CategoryNavigation
        categories={categories}
        categoryClicked={onCategoryClick}
        selectedCategoryId={selectedCategoryId}
        expandedCategory={expandedCategory}
      />
    </div>
  );
};

export default Category;
